// CORE
import React from "react";

// THIRD-PARTY LIBRARIES
import { FormattedMessage } from "react-intl";
import { v4 } from "uuid";

// API
import server from "api/server";

// ASSETS
import removeImg from "./assets/close.svg";
import { ReactComponent as UploadIcon } from "./assets/upload.svg";

// STYLES
import styles from "./styles/style.module.scss";

const ImagesUpload = ({ imagesURLs, setImageURLs, langId }) => {
    const onImageChange = (e) => {
        [...e.target.files].forEach(async (file) => {
            const formData = new FormData();
            formData.append("file", file);
            const { data } = await server().post("/upload", formData);
            console.log(data);
            const image = {
                id: v4(),
                preview: URL.createObjectURL(file),
                path: data.data.files[0].variants[0],
            };

            setImageURLs((prevImages) => [...prevImages, image]);
        });
    };

    const removeSelectedImage = (imageId) => {
        const newImages = imagesURLs.filter((image) => image.id !== imageId);
        setImageURLs(() => newImages);
    };

    return (
        <div className={styles["images-upload"]}>
            {!!langId && (
                <h5 className="title">
                    <FormattedMessage id={langId} />
                </h5>
            )}
            <label className="form-uploader">
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={onImageChange}
                    id="filo"
                />

                <UploadIcon />
            </label>
            <div className="images-wrp">
                {imagesURLs.map((image) => (
                    <div key={image.id} className="img-holder">
                        <img
                            src={image?.preview || image?.path}
                            width={100}
                            height={100}
                            alt=""
                        />
                        <button
                            className="removeImg"
                            onClick={(e) => {
                                e.preventDefault();
                                removeSelectedImage(image.id);
                            }}
                        >
                            <img src={removeImg} alt="" />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImagesUpload;
